/**
 * v-resizable
 * @desc 拖动调整大小
 * @example
 * ```vue
 * <div v-resizable                   默认为true
  :resize-data-min="minValue"         默认为0
  :resize-data-max="maxValue"         默认为400
  resize-data-direction="width"       默认为width，可选height
  resize-parent="false"               默认为否，即自己
  />
 * ```
 */

import { DirectiveBinding } from 'vue/types/options.d';

export default {
  bind(el: HTMLElement, binding: DirectiveBinding): void {
    const minValue = parseInt(el.getAttribute('resize-data-min') || '0', 10);
    const maxValue = parseInt(el.getAttribute('resize-data-max') || '400', 10);
    const direction = el.getAttribute('resize-data-direction');
    const resizeParent = el.getAttribute('resize-parent');

    el.onmousedown = (event: MouseEvent) => {
      event.preventDefault();
      const startX = event.clientX;
      let target = el;
      if (resizeParent === 'true' && el.parentElement) {
        target = el.parentElement;
      }
      let startWidth = 0;
      if (document.defaultView) {
        startWidth = parseInt(document.defaultView.getComputedStyle(target).width || '0', 10);
      }
      const startY = event.clientY;
      let startHeight = 0;
      if (document.defaultView) {
        startHeight = parseInt(document.defaultView.getComputedStyle(target).height || '0', 10);
      }

      document.onmousemove = (event: MouseEvent) => {
        if (direction === 'width') {
          let width = startWidth + (event.clientX - startX);
          if (width < minValue) {
            width = minValue;
          }
          if (width > maxValue) {
            width = maxValue;
          }
          target.style.width = `${width}px`;
        } else if (direction === 'height') {
          let height = startHeight + (event.clientY - startY);
          if (height < minValue) {
            height = minValue;
          }
          if (height > maxValue) {
            height = maxValue;
          }
          target.style.height = `${height}px`;
        }
      };
      document.onmouseup = e => {
        document.onmousemove = null;
        document.onmouseup = null;
      };
    };
  },
};
